import { useLocation } from 'react-router-dom';
import './MobileAppResetPassword.css';
import Input from '../../Input/Input';
import { useState } from 'react';
import MiniPreloader from '../../MiniPreloader/MiniPreloader';
import appApi from '../../../assets/api/AppApi';
import useAutoDismissError from '../../../assets/hooks/useAutoDismissError';

function MobileAppResetPassword() {
    const [submitError, setSubmitError] = useAutoDismissError()
    const [password, setPassword] = useState('')
    const [step, setStep] = useState(0)
    const [submitPreloader, setSubmitPreloader] = useState(false)
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');
    function handleChange(e) {
        const input = e.target;
        let value = input.value;
        setPassword(value)
    }
    function sendRequest() {
        setSubmitPreloader(true)
        appApi.updatePassword({
            password: password,
            token: token,
        })
            .then((res) => {
                console.log(res)
                setStep(1)
            })
            .catch((err) => {
                setSubmitError('Something went wrong')
            })
            .finally(() => {
                setSubmitPreloader(false)
            })
    }
    return (
        <div className='mobile-app-reset-password'>
            {step === 0 ?
                <>
                    <h3 className='mobile-app-reset-password__title'>Reset Your Password</h3>
                    <p className='mobile-app-reset-password__subtitle'>Enter a&nbsp;new password for your Sany&nbsp;Watches&nbsp;account.<br /> This link is&nbsp;valid for a&nbsp;limited time.</p>
                    <div className="personal-info__input mobile-app-reset-password__input">
                        <Input
                            label={"New Password"}
                            value={password}
                            handleChange={handleChange}
                            name={"password"}
                            inputMode='text'
                        // error={InfoValidity.email}
                        ></Input>
                    </div>
                    <button onClick={() => sendRequest()} className={`sell-with-us__submit-btn mobile-app-reset-password__submit ${password && password.length >= 8 ? 'sell-with-us__submit-btn_visible' : ''}`}>
                        {submitPreloader ? <MiniPreloader /> : 'Update Password'}
                    </button>
                    {submitError ? <p className='mobile-app-reset-password__submit-error'>{submitError}</p> : null}
                </>
                : null}
            {step === 1 ?
                <>
                    <h3 className='mobile-app-reset-password__title'>Your password has been successfully reset</h3>
                    <p className='mobile-app-reset-password__subtitle'>You can now log in&nbsp;using your new credentials</p>
                </>
                : null}
        </div>
    );
}

export default MobileAppResetPassword